import {  axiosPost, axiosPostAuthorize } from '../AxiosRequests';
import { AdminLogin, ResetPassword } from '../ApiEndPoints';

export default class AccountServices {

    //** Call login API */
    async adminLogin(request) {
        return axiosPost(AdminLogin, request);
    }

    async resetPassword(request) {
        return axiosPostAuthorize(ResetPassword, request);
    }

}